
export class WireContactModel {
    name: string;
    email: string;
    contactImageUrl: string;
    title?: string;
    primaryPhone?: string;
    secondaryPhone?: string;

    constructor(apiModel?: WireContactModel) {
        if (apiModel) {
            this.name = apiModel.name;
            this.email = apiModel.email;
            this.contactImageUrl = apiModel.contactImageUrl;
            this.title = apiModel.title;
            this.primaryPhone = apiModel.primaryPhone;
            this.secondaryPhone = apiModel.secondaryPhone;
        }
    }

    toApiModel(): WireContactModel {
        return {
            name: this.name ? this.name : null,
            email: this.email ? this.email : null,
            title: this.title ? this.title : null,
            contactImageUrl: this.contactImageUrl ? this.contactImageUrl : null,
            primaryPhone: this.primaryPhone ? this.primaryPhone : null,
            secondaryPhone: this.secondaryPhone ? this.secondaryPhone : null
        } as WireContactModel;
    }

    clone(): WireContactModel {
        return new WireContactModel(this.toApiModel());
    }

    equals(other: WireContactModel): boolean {
        const clone = this.clone();
        for (const field of Object.keys(clone)) {
            if (clone[field] !== other[field]) {
                return false;
            }
        }

        return true;
    }
}
